var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 60,
    viewBox: "0 0 132 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 132,
    height: 60,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.085.078h131.771v59.844H.085V.078Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.3 5.3a3.294 3.294 0 0 1 2.344-.971c.886 0 1.718.345 2.345.972l3.91 3.913 3.91-3.913a3.293 3.293 0 0 1 2.344-.972c.886 0 1.719.345 2.345.972a3.325 3.325 0 0 1 0 4.694l-8.6 8.607L5.3 9.995a3.325 3.325 0 0 1 0-4.694Zm23.313 28.9h-5.305l-5.622 7.55H16.08V22.43L25.5 13c2.95-2.951 2.95-7.753 0-10.705A7.508 7.508 0 0 0 20.154.078a7.51 7.51 0 0 0-5.347 2.217l-.907.908-.907-.908A7.51 7.51 0 0 0 7.644.078c-2.02 0-3.92.788-5.348 2.217-2.948 2.952-2.948 7.754 0 10.706l9.38 9.387v30.519h4.404v-7.052h2.154l5.122 7.052h5.33l-6.997-9.524 6.924-9.183Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 132,
    height: 60,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.085.078h131.771v59.844H.085V.078Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42.033 46.196c0 .69-.176 1.328-.529 1.913-.352.584-.853 1.053-1.502 1.407-.65.352-1.416.529-2.3.529-.917 0-1.671-.207-2.263-.621-.592-.414-.889-1.027-.889-1.839 0-.569.15-1.034.45-1.395.301-.36.71-.643 1.23-.846a7.709 7.709 0 0 1 1.764-.439c.292-.04.637-.089 1.034-.146.398-.057.799-.121 1.205-.195a10.46 10.46 0 0 0 1.101-.255c.328-.098.561-.203.7-.317v2.204Zm1.936-10.881a7.637 7.637 0 0 0-2.446-1.042 11.657 11.657 0 0 0-2.69-.317c-1.306 0-2.498.193-3.577.58-1.079.385-1.991.961-2.737 1.729-.747.767-1.282 1.719-1.607 2.856l4.113.584c.219-.641.643-1.197 1.271-1.668.629-.471 1.483-.707 2.562-.707 1.022 0 1.805.252 2.348.755.544.504.815 1.214.815 2.132v.072c0 .423-.156.734-.468.932-.312.2-.809.345-1.49.439-.682.093-1.57.197-2.665.31-.909.097-1.787.254-2.635.47a8.161 8.161 0 0 0-2.281.943 4.531 4.531 0 0 0-1.594 1.656c-.39.69-.584 1.563-.584 2.619 0 1.226.274 2.257.82 3.093a5.138 5.138 0 0 0 2.24 1.894c.945.426 2.01.64 3.194.64.974 0 1.823-.137 2.549-.408.726-.273 1.33-.634 1.813-1.084.483-.451.858-.936 1.126-1.456h.146v2.57h4.234v-12.52c0-1.242-.225-2.277-.675-3.105-.45-.829-1.045-1.484-1.782-1.967Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 132,
    height: 60,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.085.078h131.771v59.844H.085V.078Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M68.316 34.2h-1.144l-5.548 13.58L56.22 34.2h-5.354v18.707h4.247V40.302l4.977 12.605h3.078l5.147-12.742v12.742h4.21V34.2h-4.21Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 132,
    height: 60,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.085.078h131.771v59.844H.085V.078Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M76.979 52.907h4.21v-15.09h7.325v15.09h4.247V34.2H76.979v18.707Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 132,
    height: 60,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.085.078h131.771v59.844H.085V.078Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M104.296 48.328h-.195L99.793 34.2h-4.672l6.778 19.097-.377 1.01c-.268.707-.595 1.212-.98 1.517a2.15 2.15 0 0 1-1.332.468c-.503.009-1.076-.08-1.716-.268l-1.022 3.435c.3.122.703.23 1.21.323s1.061.14 1.662.14c1.151 0 2.143-.189 2.975-.566a5.742 5.742 0 0 0 2.111-1.632c.576-.71 1.038-1.561 1.387-2.552L113.3 34.2h-4.685l-4.319 14.127Z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 132,
    height: 60,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.085.078h131.771v59.844H.085V.078Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M126.928 48.23c-.349.471-.781.83-1.296 1.078-.516.248-1.097.372-1.746.372-.916 0-1.714-.246-2.391-.737-.677-.492-1.202-1.194-1.576-2.107-.373-.914-.56-2.008-.56-3.282 0-1.259.189-2.339.566-3.24.378-.902.907-1.594 1.588-2.076.681-.484 1.472-.725 2.373-.725 1.062 0 1.912.303 2.549.907.637.605 1.04 1.358 1.211 2.26h4.21c-.097-1.348-.495-2.528-1.193-3.539-.698-1.01-1.632-1.794-2.805-2.35-1.171-.556-2.516-.835-4.033-.835-1.825 0-3.405.409-4.739 1.225-1.335.816-2.367 1.952-3.097 3.41-.73 1.457-1.095 3.136-1.095 5.036 0 1.891.359 3.562 1.077 5.011.718 1.45 1.744 2.584 3.079 3.404 1.334.82 2.933 1.23 4.799 1.23 1.566 0 2.929-.286 4.089-.858 1.16-.573 2.076-1.369 2.75-2.387.673-1.02 1.062-2.19 1.168-3.514h-4.21c-.13.674-.369 1.246-.718 1.717Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h132v60H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLong);
export default __webpack_public_path__ + "static/media/logo-long.e49e3b4803591c2608b3d1647de8e869.svg";
export { ForwardRef as ReactComponent };